import { userFields } from './users';

const onDemandPaymentFields = {
  AMOUNT: 'Amount',
  DESCRIPTION: 'Description',
  PAYMENT_NUMBER: 'Payment Number',
  STRIPE_ID: 'Stripe ID',
  TITLE: 'Title',
  USER_ID: userFields.USER_ID,
  USER_NAME: userFields.USER_NAME,
};

export {
  onDemandPaymentFields,
};
